import { useQuery } from "@tanstack/react-query";
import { getTemplates } from "../services/knowledgeBank.service";

export const useTemplates = () => {
  return useQuery({
    queryKey: ["templates"],
    queryFn: getTemplates,
  });
};
